import React, { useState, useRef, useEffect } from 'react';

export const SUBJECT_SORT_OPTIONS = [
  { key: 'subject_primary', label: 'Subject (A–Z)' },
  { key: 'location_name', label: 'Site / location' },
  { key: 'device_name', label: 'Device name' },
  { key: 'device_identifier', label: 'Device ID' },
  { key: 'department_name', label: 'Department' },
  { key: 'physical_location', label: 'Physical location' },
  { key: 'complaint_identifier', label: 'Complaint ID' },
];

/**
 * Subject column header with sort dropdown (server sort_by keys).
 */
function SubjectSortMenu({ sorting, onSortChange, getSortIndicator }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const activeOption = SUBJECT_SORT_OPTIONS.find((o) => o.key === sorting?.sort_by);
  const isSubjectSort = Boolean(activeOption);
  const indicator = isSubjectSort ? getSortIndicator(sorting.sort_by) : '';

  const handleSelect = (key) => {
    setOpen(false);
    if (onSortChange) onSortChange(key);
  };

  return (
    <th
      ref={ref}
      className="alert-table-col-subject subject-sort-header"
    >
      <button
        type="button"
        className="subject-sort-trigger"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label="Sort Subject column — choose field to sort by"
        title="Click to choose how to sort the Subject column (device, location, complaint, etc.)"
      >
        <span className="subject-sort-title">
          Subject{indicator}
        </span>
        <span className="subject-sort-control" aria-hidden>
          <span className="subject-sort-hint">Sort by</span>
          <span className="subject-sort-icon">⇅</span>
        </span>
      </button>
      {open && (
        <ul className="subject-sort-menu" role="listbox">
          {SUBJECT_SORT_OPTIONS.map((opt) => (
            <li key={opt.key} role="option">
              <button
                type="button"
                className={`subject-sort-option${sorting?.sort_by === opt.key ? ' active' : ''}`}
                onClick={() => handleSelect(opt.key)}
              >
                {opt.label}
                {sorting?.sort_by === opt.key ? getSortIndicator(opt.key) : ''}
              </button>
            </li>
          ))}
        </ul>
      )}
    </th>
  );
}

export default SubjectSortMenu;
